import React from 'react';
import Paragraph from 'elements/Paragraph';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ds from 'designsystem';

const SocialLink = (props) => {
  const { image, children, custom } = props;
  const Social = styled.span`
    display: inline-block;
    background-image: url(${image});
    height: 20px;
    width: 20px;
    background-repeat: no-repeat;
    margin-right: 10px;
    ${custom}
  `;

  const ParagraphWhite = Paragraph.extend`
    color: ${ds.brand('white')};
    display: flex;
    align-items: center;
  `;

  SocialLink.propTypes = {
    image: PropTypes.string.isRequired,
    children: PropTypes.string.isRequired,
    custom: PropTypes.string,
  };

  return (
    <ParagraphWhite>
      <Social />
      { children }
    </ParagraphWhite>
  );
};

export default SocialLink;



// WEBPACK FOOTER //
// ./src/blocks/Footer/SocialLink.jsx